import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import classnames from "classnames";

// reactstrap components
import {
  Button,
  Card,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
} from "reactstrap";
import TextInput from "../common/TextInput";
import { RootStoreContext } from "../../app/stores/rootStore";
import {
  ISurveyDetail,
  SurveyResponseFormValue,
  SurveyResponseLanguagesFormValue,
} from "../../app/models/survey";
import Loader from "../common/Loader";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface surveyResponseParams {
  survey: ISurveyDetail;
  surveyResponseId: number;
  languages: Number[];
  onSubmit: () => void;
}

export const SurveyResposeForm: React.FC<surveyResponseParams> = ({
  surveyResponseId,
  survey,
  onSubmit,
  languages,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, loadingLanguages, loadLanguages } = rootStore.commonStore;
  const { allLanguages } = rootStore.commonStore;

  const {
    LoadSurveyresponsesDetail,
    createSurveyResponse,
    updateSurveyResponse,
  } = rootStore.surveyStore;
  const [activeTab, setActiveTab] = useState("1");
  const [formValues, setFormValues] = useState(new SurveyResponseFormValue());
  const [t] = useTranslation(
    ["surveys", "translation"],
    translationHookOptions
  );

  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (!allLanguages || allLanguages.length === 0) {
      loadLanguages().then().catch();
    }
    // console.log("lingue selezionate " + JSON.stringify(languages));
    if (surveyResponseId > 0) {
      LoadSurveyresponsesDetail(surveyResponseId)
        .then((dto) => {
          let surveyresponseForm = new SurveyResponseFormValue();
          languages.forEach((l) => {
            var response = dto.responsesLanguages.find(
              (f) => f.languageId === l
            );
            if (response) surveyresponseForm.responseLanguages.push(response);
            else {
              surveyresponseForm.responseLanguages.push(
                new SurveyResponseLanguagesFormValue({
                  languageId: parseInt(l.toString()),
                  response: "",
                })
              );
            }
          });

          setFormValues(surveyresponseForm);
        })
        .catch();
    } else {
      let surveyresponseForm = new SurveyResponseFormValue();
      languages.forEach((l) => {
        surveyresponseForm.responseLanguages.push(
          new SurveyResponseLanguagesFormValue({
            languageId: parseInt(l.toString()),
            response: "",
          })
        );
      });

      setFormValues(surveyresponseForm);
    }

    return () => {};
  }, [
    loadLanguages,
    allLanguages,
    survey.questionsLanguages,
    surveyResponseId,
    LoadSurveyresponsesDetail,
    setFormValues,
  ]);

  if (loadingLanguages || !formValues) return <Loader />;

  return (
    <>
      <FinalForm
        initialValues={formValues}
        onSubmit={(values: SurveyResponseFormValue) => {
          let formToSend = new SurveyResponseFormValue({
            responseLanguages: [],
          });
          values.responseLanguages.forEach((l: any) => {
            formToSend.responseLanguages.push(l);
          });

          if (surveyResponseId > 0) {
            updateSurveyResponse(surveyResponseId, formToSend)
              .then(() => onSubmit())
              .catch((error) => ({
                [FORM_ERROR]: error,
              }));
          } else {
            createSurveyResponse(survey.surveyId, formToSend)
              .then(() => onSubmit())
              .catch((error) => ({
                [FORM_ERROR]: error,
              }));
          }
        }}
        validate={(values) => {
          let errors = {};
          let errorNum = 0;
          if (values.responseLanguages.length > 0) {
            values.responseLanguages.forEach((l) => {
              if (!l.response) errorNum++;
            });
          }
          if (errorNum === 0) return errors;
          else return { count: errorNum };
        }}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
          values,
          form,
        }) => (
          <Form onSubmit={handleSubmit} fluid="true">
            <Row>
              <Col sm={12}>
                <Nav tabs className="navQuestion">
                  {languages &&
                    languages.map((l) => (
                      <NavItem key={l.toString()}>
                        <NavLink
                          href="#"
                          className={classnames("surveyNavLinkResponse", {
                            active: activeTab === l.toString(),
                          })}
                          onClick={() => {
                            toggle(l.toString());
                          }}
                        >
                          <span
                            className={classnames(
                              "mr-1 flag-icon fa-2x",
                              allLanguages.filter((x) => x.id === l)[0].flagIcon
                            )}
                          ></span>
                          {/* {allLanguages.filter((x) => x.id === l)[0].name} */}
                        </NavLink>
                      </NavItem>
                    ))}
                </Nav>
                <TabContent activeTab={activeTab} className="pt-0 tabQuestion">
                  {languages &&
                    languages.map((item, index) => (
                      <TabPane
                        key={item.toString()}
                        tabId={item.toString()}
                        className="tabPaneSurvey"
                      >
                        <Row>
                          <Col>
                            <Card body className="questionCard ">
                              <Field
                                name={`responseLanguages[${
                                  values.responseLanguages.findIndex(
                                    (x) => x.languageId === item
                                  ) > -1
                                    ? values.responseLanguages.findIndex(
                                        (x) => x.languageId === item
                                      )
                                    : values.responseLanguages.length
                                }].languageId`}
                                component={TextInput}
                                placeholder="Nome"
                                type="hidden"
                                className="form-control-alternative"
                                autoComplete="off"
                                defaultValue={item}
                              />
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor={`responseLanguages[${
                                    values.responseLanguages.findIndex(
                                      (x) => x.languageId === item
                                    ) > -1
                                      ? values.responseLanguages.findIndex(
                                          (x) => x.languageId === item
                                        )
                                      : values.responseLanguages.length
                                  }].response`}
                                >
                                  {t("answer_modal_label")}
                                </label>
                                <Field
                                  name={`responseLanguages[${
                                    values.responseLanguages.findIndex(
                                      (x) => x.languageId === item
                                    ) > -1
                                      ? values.responseLanguages.findIndex(
                                          (x) => x.languageId === item
                                        )
                                      : values.responseLanguages.length
                                  }].response`}
                                  component={TextInput}
                                  type="textarea"
                                  className="form-control-alternative"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </Card>
                          </Col>
                        </Row>
                      </TabPane>
                    ))}
                </TabContent>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={12} className="text-center">
                <Button
                  disabled={invalid || pristine}
                  type="submit"
                  className={classNames(
                    "surveyButton pr-4 pl-4",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                >
                  {t("save", { ns: "translation" })}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      ></FinalForm>
    </>
  );
};
export default observer(SurveyResposeForm);
